import styled from "styled-components";
import {Steps} from "antd";

export const Container = styled.div`
    .ant-steps-item {
        position: relative;
    }
    .ant-steps-item-icon {
        position: relative;
    }
    .ant-steps-item-tail {
        padding: 0 !important;
        margin: 0 !important;
        left: 3.5px !important;
        &::after {
            height: 100% !important;
            margin: 0 !important;
            margin-left: 0 !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            top: 0 !important;
            width: 2px;
        }
    }
    .ant-steps-vertical .ant-steps-item-tail {
        margin-left: 0 !important;
        padding: 0 !important;
        &::after {
            height: 100% !important;
            margin-left: 0 !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            top: 0 !important;
        }
    }
    .ant-steps-vertical .ant-steps-item:not(:last-child) .ant-steps-item-tail {
        &::after {
            height: calc(100% + 0px) !important;
        }
    }

    .ant-steps-item-title {
        margin-top: -6px !important;
    }
`;

export const TrialStepContainer = styled.div`
    border-left: 1px solid ${({iscompleted}) => (iscompleted === "true" ? "#1890ff" : "#f0f0f0")};
    margin-left: 3px;
`;

export const TrialStep = styled(Steps.Step)`
    padding-left: 20px !important;
    .ant-steps-item-tail {
        &:after {
            display: none;
        }
    }
`;

export const TrialTitle = styled.div`
    color: ${({iscompleted}) =>
        iscompleted === "true" ? "rgba(0, 0, 0, 0.85)" : "rgba(0, 0, 0, 0.45)"};
`;
